import "./ColorSetting.css"
import { useDispatch,useSelector } from "react-redux"
import { setFrame1,setFrame2,setFrame3,setFrame4,setFrame5,setFrame6 } from "../../../actions"
import { useEffect } from "react"

const ColorSetting = () => {

    const dispatch = useDispatch()
    const frame = useSelector(state => state.frame)

    useEffect(()=>{
        const buttons = document.querySelectorAll(".colorBtn")
        buttons.forEach((button) => {
            if (parseInt(button.value) === frame.btn){
                button.classList.add("selected")
            }else{
                button.classList.remove("selected")
            }
            
        })
    },[frame.btn])


    const handleClick = (callback) => {
        dispatch(callback())
    }

    return(
        <div className="ColorSetting">
            <button className="colorBtn btn1" value={1} onClick={() => handleClick(setFrame1)}></button>
            <button className="colorBtn btn2" value={2} onClick={() => handleClick(setFrame2)}></button>
            <button className="colorBtn btn3" value={3} onClick={() => handleClick(setFrame3)}></button>
            <button className="colorBtn btn4" value={4} onClick={() => handleClick(setFrame4)}></button>
            <button className="colorBtn btn5" value={5} onClick={() => handleClick(setFrame5)}></button>
            <button className="colorBtn btn6" value={6} onClick={() => handleClick(setFrame6)}></button>
        </div>
    )
}

export default ColorSetting